import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import * as dayjs from 'dayjs';
import { CaptionPipe } from 'src/app/core/_base/layout/pipes/caption.pipe';
import { CatalogCategory, CatalogueService } from 'src/app/provider/catalogue.service';
import { ItemService } from 'src/app/provider/item.service';
import { PromotionService } from 'src/app/provider/promotion.service';
import { MenuItemCatalogGroupModel } from 'src/app/views/models/menu-item-catalog-group.model';
import { MenuItemCatalogModel } from 'src/app/views/models/menu-item-catalog.model';
import { PromotionHeader, PromotionLine } from 'src/app/views/models/promotion.model';
import { TokenFormModel } from 'src/app/views/pages/auth/models/tokenform.model';

@Component({
  selector: 'kt-new-promotion',
  templateUrl: './new-promotion.component.html',
  styleUrls: ['./new-promotion.component.scss']
})
export class NewPromotionComponent implements OnInit {

  productsCategories: CatalogCategory[] = [];
  allProducts: MenuItemCatalogModel[] = [];
  allCategories: MenuItemCatalogGroupModel[] = [];

  newData: PromotionHeader = new PromotionHeader();

  profile: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));

  newItem: {
    item: MenuItemCatalogModel;
    type: string;
    value: number;
    category: MenuItemCatalogGroupModel;
  } = {
      item: null,
      category: null,
      type: null,
      value: null
    };

  newPromotionItem: {
    item: MenuItemCatalogModel;
    type: string;
    value: number;
    category: MenuItemCatalogGroupModel;
  } = {
      item: null,
      category: null,
      type: null,
      value: null
    };

  definitionProducts: {
    item: MenuItemCatalogModel;
    type: string;
    value: number;
    category: MenuItemCatalogGroupModel;
  }[] = [];

  promotionItems: {
    item: MenuItemCatalogModel;
    type: string;
    value: number;
    category: MenuItemCatalogGroupModel;
  }[] = [];

  constructor(
    public myService: CatalogueService,
    private captionPipe: CaptionPipe,
    private matDialog: MatDialog,
    private promotionServ: PromotionService,
    private itemServ: ItemService
  ) { }

  close() {
    this.matDialog.closeAll();
  }

  async ngOnInit() {
    this.productsCategories = await this.myService.getData(this.myService.menuItemId);

    this.productsCategories.forEach(category => {

      this.allCategories.push(category.category);

      category.items.forEach(item => {
        this.allProducts.push(item);
      });
    });
  }

  showName = (data: MenuItemCatalogModel) => {
    return this.captionPipe.transform(data.name);
  }

  async save() {
    this.newData.start_date = dayjs(this.newData.start_date).toISOString();
    this.newData.end_date = dayjs(this.newData.end_date).toISOString();
    this.newData.hotel_id = this.profile.app_hotel_id;
    this.newData.menu_section_id = 157;
    this.newData.menu_item_id = this.myService.menuItemId;
    this.newData.menu_category_id = this.itemServ.record_change$.getValue().menu_category_id;

    for (const definition of this.definitionProducts) {
      const LINE = new PromotionLine();
      LINE.line_type = 'promotion_definition';
      LINE.menu_item_catalog_group_id = definition.category ? definition.category.id : definition.item.menu_item_catalog_group_id;
      LINE.menu_item_catalog_group_name = this.productsCategories.find(x => x.category.id === (definition.category ? definition.category.id : definition.item.menu_item_catalog_group_id)).category.name;
      LINE.menu_item_catalog_id = definition.category ? 0 : definition.item.id;
      LINE.menu_item_catalog_name = definition.category ? '' : definition.item.name;
      LINE.type = definition.type;
      LINE.value = definition.value;

      this.newData.promotion_defs.push(LINE);
    }

    for (const promotion of this.promotionItems) {
      const LINE = new PromotionLine();
      LINE.line_type = 'promotions';
      LINE.menu_item_catalog_group_id = promotion.category ? promotion.category.id : promotion.item.menu_item_catalog_group_id;
      LINE.menu_item_catalog_group_name = this.productsCategories.find(x => x.category.id === (promotion.category ? promotion.category.id : promotion.item.menu_item_catalog_group_id)).category.name;
      LINE.menu_item_catalog_id = promotion.category ? 0 : promotion.item.id;
      LINE.menu_item_catalog_name = promotion.category ? '' : promotion.item.name;
      LINE.type = promotion.type;
      LINE.value = promotion.value;

      this.newData.promotions.push(LINE);
    }

    try {
      await this.promotionServ.postPromotion(this.newData);
      await this.promotionServ.getPromotions();
      this.matDialog.closeAll();
    } catch { }
  }
}
